// @ts-nocheck
import {
  computed,
  onMounted,
  defineComponent,
  getCurrentInstance,
  ComponentInternalInstance,
  ref,
} from 'vue-demi';
import HeaderStepNew from '@/components/header-step-new.vue';
import CreationFooter from '@/components/creation-footer.vue';
import { objectiveTypes } from './const';
import { getDraft } from './state';
import { saveDraft, setDraft } from './../globalActions';
import { getCreativeAuthInfo } from './../../service/index';
import adsCreativeStore from './../../store/modules/ads_creative/index';
import ForwardPc from '@/pages/objective/forward-pc-new.vue';
import blocks from '@/components/common/blocks.vue';
import teaTracker from './../../tea-tracker';
import { TEA_EVENT } from './../../const/state/TeaNames';
import { reportXFmp } from './../../plugin/perfMeasurePlugin';
import { useObjectiveHooks } from './../../hooks/creation/objective/objectiveStatus';
import identityStore from './../../store/modules/identity/index';
import { useWhiteListHooks } from './../../hooks/global/useWhiteListHooks';
import interestBehaviorState from '../../store/modules/smart-interests-and-behaviors';
import { SmartInterestType } from '../../const/state/adgroup';
import { IS_VALID_OBJECTIVE_TYPE } from './../audience/utils';
const name = 'objective';
export default defineComponent({
  name,
  components: {
    ForwardPc,
    CreationFooter,
    HeaderStepNew,
    blocks,
  },
  setup() {
    const id = ref('');
    const { proxy: _this } = getCurrentInstance() as ComponentInternalInstance;
    const { entryWhitelist } = useWhiteListHooks();
    const isFromCreation = computed(() => adsCreativeStore.getters.campaignFormData.value.fromCreation);
    const { isInvalidObjectiveForCreation, currentObjectiveType } = useObjectiveHooks();
    const updateObjective = (objective): void => {
      teaTracker.trackEvent(TEA_EVENT[`${objective}_CLICK`]);
      adsCreativeStore.mutations.setObjective(objective);
      adsCreativeStore.mutations.init();
      // Set Smart-Interest-Behavior state to false if switched to Product Sales or Community Interaction objective
      // else reset to default state for smart-interest-behavior
      if (!IS_VALID_OBJECTIVE_TYPE.value) {
        interestBehaviorState.mutations.removeSmartInterestState();
      } else {
        interestBehaviorState.mutations.resetDefaultValues();
      }
    };
    const handleNextStep = async (router, route): Promise<void> => {
      teaTracker.trackEvent(TEA_EVENT.CONTINUE, {
        objective_type: currentObjectiveType.value,
        page: 'objective',
      });
      _this.$Loading.show();
      await saveDraft();
      if (adsCreativeStore.getters.creativeFormData.value.selectedObjective) {
        adsCreativeStore.mutations.setResetAfterSwitchObjective();
        identityStore.mutations.setIdentityStatus(false);
        identityStore.mutations.setUseTikTokIdentity(false);
      } else {
        adsCreativeStore.mutations.setSelectedObjective(true);
      }
      router.push({ name: 'creative', query: { ...route.query } });
      // stop(id.value);
    };
    const initSetup = () => {
      _this.$Loading.hide();
      teaTracker.trackEvent(TEA_EVENT.SHOW_OBJECTIVE_PAGE, {
        source: 'new',
      });
      adsCreativeStore.mutations.setSetFromDraft(false);
    };
    const checkAuth = async (): Promise<void> => {
      const authData = await getCreativeAuthInfo();
      adsCreativeStore.mutations.setIsCreativeAuthorized(authData?.data?.is_check);
    };
    onMounted(async () => {
      reportXFmp();
      await entryWhitelist();
      initSetup();
      await checkAuth();
      if (isFromCreation.value && adsCreativeStore.state.identity.init.value) {
        return;
      }
      const { data } = await getDraft();
      const { has_draft = false, draft_json = {} } = data;
      // update smart_interest_behavior from draft mode
      if (draft_json) {
        const { audience } = draft_json;
        audience?.smart_interest_behavior &&
          interestBehaviorState.mutations.setSmartInterestSelection(
            (audience.smart_interest_behavior as number) === SmartInterestType.CHECK,
          );
      }
      if (!has_draft) {
        return;
      }
      try {
        await _this.$confirm(_this.$t('module_fastcreation_draft_hint'), {
          cancelButtonText: _this.$t('module_fastcreation_draft_startover'),
          confirmButtonText: _this.$t('module_fastcreation_draft_continue'),
        });
        setDraft(draft_json);
        adsCreativeStore.mutations.setSelectedObjective(false);
      } catch (e) {
        adsCreativeStore.mutations.init();
      }
    });
    return {
      name,
      list: objectiveTypes,
      handleNextStep,
      updateObjective,
      disableNextButton: isInvalidObjectiveForCreation,
      currentObjectiveType,
    };
  },
});
